<template>
  <v-autocomplete
    :items="filter_content_lists(filter, typefilter)"
    v-model="val"
    :label="label || title"
    :item-text="item => item.id + ' ' + item.name"
    item-value="id"
    :clearable="(clearable == false ? false : true)"
    :multiple="multiple"
    :chips="multiple"
    :small-chips="multiple"
    :deletable-chips="multiple">
  ></v-autocomplete>
</template>
  
<script>
export default {
	props: [
		'name',
		'value',
		'label',
    'title',
    'filter',
    'multiple',
    'typefilter',
    'clearable'
	],
  methods: {
   filter_content_lists (filter, typefilter) {
      var self = this;
      if (typeof(filter) != "undefined") {
        var lists = _.filter(this.content_lists, (cl) => {
          return cl.type == filter;
        });
        return _.map(lists, (list) => { return {id: list.id, name: this.get_list_name (list)}; });
      }
      if (typeof(typefilter) != "undefined") {
        var lists = _.filter(this.content_lists, (cl) => {
          var list_type = this.$store.state.cms_list_types[cl.cms_list_type_id];
          return list_type.name == typefilter;
        });
        return _.map(lists, (list) => { return {id: list.id, name: this.get_list_name (list)}; });
      }
      var lists = this.content_lists;
      return _.map(lists, (list) => { return {id: list.id, name: this.get_list_name (list)}; });
    },
    get_list_name (list) {
      return this.get_tree_name(list, "", []);
    },
    get_tree_name (list, acc, ids) {
      var parent = this.$store.state.cms_lists[list.meta.parent_list_id];
      if(typeof(parent) == "undefined" || ids.indexOf(list.meta.parent_list_id) != -1) {
        return (acc != "" ? list.name + " / " + acc : list.name);
      } else {
        ids.push(parent.id);
        return this.get_tree_name(parent, (acc != "" ? list.name + " / " + acc : list.name), ids);
      }
    },
  },  
	computed: {
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>